{
  "name": "@h1-card/h1-lib-ui",
  "version": "v1.0.0",
  "author": "H1 Card",
  "dependencies": {
    "@babel/runtime": "^7.21.0",
    "@emotion/react": "^11.11.0",
    "@emotion/styled": "^11.11.0",
    "@mui/material": "^5.12.3",
    "@mui/x-date-pickers": "^6.3.1",
    "classnames": "^2.3.2",
    "core-js": "^3.30.0",
    "date-fns": "^2.30.0",
    "file-saver": "^2.0.5",
    "lint-staged": "^13.2.1",
    "moment": "^2.29.4",
    "prettier": "^2.8.7",
    "react-app-polyfill": "^3.0.0",
    "react-content-loader": "^6.2.1",
    "react-copy-to-clipboard": "^5.1.0",
    "react-day-picker": "^8.7.1",
    "react-easy-crop": "^4.7.4",
    "react-modal-image": "^2.6.0",
    "react-scripts": "5.0.1",
    "react-window": "^1.8.8",
    "recharts": "^2.5.0",
    "styled-components": "^5.3.9",
    "typeface-muli": "^1.1.13",
    "uninstall": "^0.0.0",
    "uniqid": "^5.4.0",
    "web-vitals": "^2.1.4"
  },
  "scripts": {
    "start": "react-scripts start",
    "build": "react-scripts build",
    "test": "react-scripts test",
    "eject": "react-scripts eject",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "make build-storybook",
    "build-icons": "node scripts/build-icons/build.js",
    "semantic-release": "semantic-release",
    "version": "git add -A .",
    "cz": "npx git-cz",
    "dist": "rm -rf dist && NODE_ENV=production npx babel src/lib --presets=@babel/preset-react --plugins=@babel/proposal-class-properties --out-dir dist --copy-files --no-copy-ignored"
  },
  "eslintConfig": {
    "extends": [
      "react-app",
      "react-app/jest"
    ],
    "overrides": [
      {
        "files": [
          "**/*.stories.*"
        ],
        "rules": {
          "import/no-anonymous-default-export": "off"
        }
      }
    ]
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@babel/cli": "^7.21.0",
    "@babel/core": "^7.21.4",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-export-default-from": "^7.18.10",
    "@babel/plugin-proposal-object-rest-spread": "^7.20.7",
    "@babel/plugin-transform-react-jsx": "^7.21.0",
    "@babel/preset-env": "^7.22.5",
    "@babel/preset-react": "^7.18.6",
    "@babel/preset-stage-2": "^7.8.3",
    "@storybook/addon-essentials": "^7.0.10",
    "@storybook/addon-interactions": "^7.0.10",
    "@storybook/addon-links": "^7.0.10",
    "@storybook/blocks": "^7.0.10",
    "@storybook/manager-api": "^7.0.10",
    "@storybook/preset-create-react-app": "^7.0.10",
    "@storybook/react": "^7.0.10",
    "@storybook/react-webpack5": "^7.0.10",
    "@storybook/testing-library": "^0.1.0",
    "@storybook/theming": "^7.0.10",
    "@svgr/core": "^7.0.0",
    "@svgr/plugin-jsx": "^7.0.0",
    "@svgr/plugin-prettier": "^7.0.0",
    "@svgr/plugin-svgo": "^7.0.0",
    "@testing-library/dom": "^9.2.0",
    "@testing-library/jest-dom": "^5.16.5",
    "@testing-library/react": "^12.1.5",
    "@testing-library/user-event": "^13.5.0",
    "babel-plugin-named-exports-order": "^0.0.2",
    "cheerio": "^1.0.0-rc.12",
    "commitizen": "^4.3.0",
    "cz-conventional-changelog": "^3.3.0",
    "element-to-path": "^1.2.1",
    "fs-extra": "^11.1.1",
    "husky": "^8.0.3",
    "jest-styled-components": "^7.1.1",
    "node-dir": "^0.1.17",
    "prop-types": "^15.8.1",
    "react-router": "^6.10.0",
    "react-test-renderer": "^17.0.2",
    "sass": "^1.62.0",
    "semantic-release": "^21.0.1",
    "storybook": "^7.0.10",
    "svgo": "^3.0.2",
    "uppercamelcase": "^3.0.0",
    "write": "^2.0.0"
  },
  "peerDependencies": {
    "react": "^17.0.0 || ^18.0.0",
    "react-dom": "^17.0.0 || ^18.0.0"
  },
  "lint-staged": {
    "src/**/*.{js,jsx,json,css}": [
      "prettier --config .prettierrc --write",
      "git add"
    ]
  },
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged"
    }
  },
  "config": {
    "commitizen": {
      "path": "cz-conventional-changelog"
    }
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/H1-Card/lib-ui.git"
  },
  "description": "The frontend components library",
  "publishConfig": {
    "access": "public"
  },
  "module": "dist/index",
  "main": "dist/index",
  "files": [
    "dist",
    "README.md"
  ]
}
